var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "QR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-336.000000, -712.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.625
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-18",
    transform: "translate(145.000000, 704.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QR",
    transform: "translate(193.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.48661277,11.5886303 C5.59990392,12.6990976 6.49630133,13.5964438 7.60549209,13.7148727 C8.25856184,13.7846034 8.92678327,13.8403278 9.60666872,13.8403278 C10.2865773,13.8403278 10.9547987,13.7846034 11.6078684,13.7148727 C12.7170592,13.5964438 13.6134335,12.6990976 13.7267478,11.5886303 C13.7930133,10.9392822 13.8451896,10.2749108 13.8451896,9.59898324 C13.8451896,8.92303253 13.7930133,8.25868433 13.7267478,7.60931308 C13.6134335,6.49884573 12.7170592,5.60152266 11.6078684,5.48307065 C10.9547987,5.41333997 10.2865773,5.35761553 9.60666872,5.35761553 C8.92678327,5.35761553 8.25856184,5.41333997 7.60549209,5.48307065 C6.49630133,5.60152266 5.59990392,6.49884573 5.48661277,7.60931308 C5.42034727,8.25868433 5.36817098,8.92303253 5.36817098,9.59898324 C5.36817098,10.2749108 5.42034727,10.9392822 5.48661277,11.5886303 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.944768,0 C21.8012074,0.0923301623 22.6500249,0.191305193 23.4905274,0.288770973 C25.7066916,0.545806052 27.4750035,2.31412697 27.72399,4.53265796 C27.8177641,5.36827043 27.9122311,6.21218032 28,7.06374047",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.944768,28 C21.8012074,27.9077808 22.6500249,27.8086278 23.4905274,27.7113238 C25.7066916,27.4543118 27.4750035,25.6859678 27.72399,23.4673906 C27.8177641,22.6316394 27.9122311,21.7877989 28,20.936285",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0553429,0 C6.19878793,0.0923301623 5.34994739,0.191305193 4.50949108,0.288770973 C2.29334999,0.545806052 0.525038052,2.31412697 0.27614399,4.53265796 C0.182392969,5.36827043 0.0878635768,6.21218032 0,7.06374047",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0553429,28 C6.19878793,27.9077808 5.34994739,27.8086278 4.50949108,27.7113238 C2.29334999,27.4543118 0.525038052,25.6859678 0.27614399,23.4673906 C0.182392969,22.6316394 0.0878635768,21.7877989 0,20.936285",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "6.14210771 19.1157065 6.14210771 22.6475871 9.60666872 22.6475871"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "22.5377731 22.6475871 22.5377731 19.1156371 19.073189 19.1156371"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.6008281,
    y1: 13.9478245,
    x2: 19.1361978,
    y2: 13.9478245,
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.8451896,
    y1: 22.6149984,
    x2: 13.8451896,
    y2: 19.1481566,
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "22.5377731 9.59898324 22.5377731 6.06712572 19.073189 6.06712572"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetAppIcon);
export default __webpack_public_path__ + "static/media/getAppIcon.c43d7cdb63242e9fae6a6e4df3d99299.svg";
export { ForwardRef as ReactComponent };